<ng-container *ngFor="let icon of icons">
  <ins-icon-container [icon]="icon"></ins-icon-container>
</ng-container>
<div class="overflow-text-container">
  <ins-overflow-span [tooltipDisabled]="!showTooltip" [content]="dataToRender"></ins-overflow-span>
</div>
